import PropTypes from "prop-types";
import React from "react";

import { LargeIconButton } from "common/DS/IconButtons";
import SVGIcon from "common/SVGIcon";
import { alphaNumeric } from "lib/propTypes";
import * as Icons from "common/DS/Icons";
import { OutlinedButton } from "common/DS/Buttons";
import { Subtitle2 } from "common/DS/Text";
import rollbar from "lib/rollbar";

export const getAnswerDisplayPropsFromAnswer = (answer) => {
    // Use `display_text` if present, otherwise use `value` unless `display_value` is false
    const displayValue = answer.display_value !== false ? answer.value : undefined;
    const displayText = answer.display_text || displayValue;

    return {
        icon: answer.display_icon,
        svg: answer.display_svg,
        number: answer.display_number,
        text: displayText,
    };
};

const QuestionAnswerDisplay = ({ icon, svg, number, text }) => {
    let content = null;

    if (icon) {
        const Icon = Icons[icon];
        if (Icon) {
            content = (
                <LargeIconButton>
                    <Icon />
                </LargeIconButton>
            );
        } else {
            rollbar.error("Invalid AnswerDisplay icon", {
                icon,
                text,
            });
        }
    }

    if (svg) {
        content = (
            <LargeIconButton>
                <SVGIcon icon={svg} />
            </LargeIconButton>
        );
    }

    if (number) {
        content = (
            <OutlinedButton className="check-in__int-button" size="large">
                {number}
            </OutlinedButton>
        );
    }

    if (content === null) {
        return text;
    }

    return (
        <div className="flex flex-col">
            {content}
            {text && <Subtitle2 className="check-in__display-text">{text}</Subtitle2>}
        </div>
    );
};

QuestionAnswerDisplay.propTypes = {
    icon: PropTypes.string,
    svg: PropTypes.string,
    number: alphaNumeric,
    text: PropTypes.string,
};

QuestionAnswerDisplay.defaultProps = {
    icon: null,
    svg: null,
    number: null,
    text: null,
};

export default React.memo(QuestionAnswerDisplay);
